module.exports = __webpack_public_path__ + "media/images/athletes/1168-fe1b909ace44ff2d3e6d811cde40417d.png";